import { serverHost } from "variables/serverdata";

// ----------------------------
// GET EMAIL TEMPLATE
// ----------------------------
export const getEmailTemplate = async (template_uuid) => {
    try {
        const response = await fetch(`${serverHost}/get_email_template/${template_uuid}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch email template: ${response.statusText}`);
        }
        return await response.json();
    } catch (err) {
        console.error(err);
        return { error: err.message };
    }
};

// ----------------------------
// INSERT NEW EMAIL TEMPLATE
// ----------------------------
export const insertEmailTemplate = async (emailTemplate, domain_uuid, user_uuid) => {
    try {
        const response = await fetch(`${serverHost}/create_email_template`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ emailTemplate, domain_uuid, user_uuid }),
        });

        if (!response.ok) {
            throw new Error(`Failed to insert email template: ${response.statusText}`);
        }
        return await response.json();
    } catch (err) {
        console.error(err);
        throw err;
    }
};

// ----------------------------
// UPDATE EXISTING EMAIL TEMPLATE
// ----------------------------
export const updateEmailTemplate = async (emailTemplate, domain_uuid, user_uuid) => {
    try {
        const response = await fetch(`${serverHost}/update_email_template/${emailTemplate.email_template_uuid}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ emailTemplate, domain_uuid, user_uuid }),
        });

        if (!response.ok) {
            throw new Error(`Failed to update email template: ${response.statusText}`);
        }
        return await response.json();
    } catch (err) {
        console.error(err);
        throw err;
    }
};
